module.exports = __webpack_public_path__ + "img/grenada-1.ce698579.png";